import { render, staticRenderFns } from "./EditionOverview.vue?vue&type=template&id=425311a2&scoped=true"
import script from "./EditionOverview.vue?vue&type=script&lang=js"
export * from "./EditionOverview.vue?vue&type=script&lang=js"
import style0 from "./EditionOverview.vue?vue&type=style&index=0&id=425311a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425311a2",
  null
  
)

export default component.exports